import Logo from '../../../Visuals/Images/Logo.png';
import React, { useState } from 'react';
import {
  FooterDiv,
  FooterRow,
  FooterCol,
  FooterLinks,
  FooterBottomRow,
  FooterBottomItem,
  FooterInner,
  FooterBrand,
  FooterBottomLinks,
  FooterCredit,
  FooterPWASection,
  FooterPWAContent,
  FooterPWAIcon,
  FooterPWAText,
  FooterPWAButton,
} from './FooterStyles.styles';
import usePWAInstall from '../../../Components/PWA/usePWAInstall';
import PWAInstallModal from '../../../Components/PWA/PWAInstallModal';
import { FiSmartphone, FiArrowUpRight } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const Footer = () => {
  const [installModalOpen, setInstallModalOpen] = useState(false);

  const { canInstall, installed, install } = usePWAInstall();

  const handleInstall = async () => {
    if (canInstall) {
      const accepted = await install();

      if (accepted) {
        setInstallModalOpen(false);
      }
    } else {
      setInstallModalOpen(true);
    }
  };

  return (
    <>
      <FooterDiv>
        <FooterInner>
          <FooterRow>
            <FooterBrand>
              <img src={Logo} alt="Yoda Safety Services Logo" />
              <p>
                Workplace safety, training, audits, and compliance support for
                businesses across Atlantic Canada.
              </p>
            </FooterBrand>

            <FooterCol>
              <h5>Contact</h5>
              {/* Insert real content here */}
              <p>825 Ostrea Lake Road, Ostrea Lake</p>
              <p>Nova Scotia, Canada</p>
              <p>yodasafetyservices1@outlook.com</p>
              <p>(902) 478-1972</p>
            </FooterCol>

            <FooterCol>
              <h5>Explore</h5>

              <FooterLinks>
                <Link to="/">Home</Link>
                <Link to="/about">About Us</Link>
                <Link to="/training">Online Training</Link>
                <Link to="/resources">Resources</Link>
                <Link to="/news">News & Updates</Link>
                <Link to="/contact-us">Contact Us</Link>
              </FooterLinks>
            </FooterCol>

            <FooterCol>
              <h5>Account</h5>

              <FooterLinks>
                <Link to="/login">Login</Link>
                <Link to="/privacy-policy">Privacy Policy</Link>
                <Link to="/terms-and-conditions">Terms & Conditions</Link>
              </FooterLinks>
            </FooterCol>
          </FooterRow>

          {!installed && (
            <FooterPWASection>
              <FooterPWAContent>
                <FooterPWAIcon>
                  <FiSmartphone />
                </FooterPWAIcon>

                <FooterPWAText>
                  <span>YODA ON THE GO</span>

                  <h3>Your training, one tap away.</h3>

                  <p>
                    Add YODA to your home screen for easy access to your
                    training, courses, and certificates.
                  </p>
                </FooterPWAText>
              </FooterPWAContent>

              <FooterPWAButton onClick={handleInstall}>
                Install YODA
                <FiArrowUpRight />
              </FooterPWAButton>
            </FooterPWASection>
          )}

          <FooterBottomRow>
            <div style={{ display: 'flex', flexDirection: 'column' }}>
              <FooterBottomItem>
                &copy; {new Date().getFullYear()} Yoda Safety Services. All
                rights reserved.
              </FooterBottomItem>
              <FooterCredit>
                Website by{' '}
                <a
                  href="https://vrbwebdesignanddev.com"
                  target="_blank"
                  rel="nofollow noreferrer"
                >
                  VRB Web Design & Development
                </a>
              </FooterCredit>
            </div>
            <FooterBottomLinks>
              <Link to="/privacy-policy">Privacy Policy</Link>
              <span>•</span>
              <Link to="/terms-and-conditions">Terms & Conditions</Link>
            </FooterBottomLinks>
          </FooterBottomRow>
        </FooterInner>
      </FooterDiv>

      <PWAInstallModal
        isOpen={installModalOpen}
        onClose={() => setInstallModalOpen(false)}
        onInstall={handleInstall}
        canInstall={canInstall}
      />
    </>
  );
};

export default Footer;
